import { Card, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';
import { Maru } from 'pages/Top/style';

type Props = {
  number: string;
  title: string;
  explanatoryText: React.ReactNode;
  flowImage: string;
};

const UsageFlowCard = (props: Props) => {
  const { number, title, explanatoryText, flowImage } = props;

  return (
    <Card
      sx={{
        width: '280px',
        borderRadius: '10px',
        textAlign: 'center',
        paddingBottom: '20px',
        border: `1px solid ${baseColors.red}`,
        position: 'relative',
        overflow: 'visible'
      }}
    >
      <div style={{ position: 'relative' }}>
        <Maru>
          <span>{number}</span>
        </Maru>
      </div>
      <Typography
        variant="h5"
        sx={{
          color: baseColors.blackGray,
          fontSize: '18px',
          borderRadius: '10px 10px 0 0',
          padding: '35px 0 10px 0',
          textAlign: 'center',
          position: 'relative'
        }}
      >
        {title}
      </Typography>
      <div style={{ minHeight: '95px' }}>
        <img src={flowImage} alt={title} />
      </div>
      <Typography
        component="div"
        variant="body1"
        sx={{
          padding: '10px',
          textAlign: 'center',
          fontSize: '12px',
          color: baseColors.blackGray
        }}
      >
        {explanatoryText}
      </Typography>
    </Card>
  );
};
export default UsageFlowCard;
